import validate from "/usr/src/app/content/n3-spas-fbaae037-39b0-4064-8891-2fccd239b720/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-fbaae037-39b0-4064-8891-2fccd239b720/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}